// MVS-013 · v1.0 · 追问规则库（v0.3.1 askRules + fallbackAsks 原样搬运）
// 触发逻辑保留在 app.js 的 rescanAsks/currentAsks/commitAsk/skipAsk，
// 这里只 export 规则数据；T6 若要重构可拆出独立 store 片段。

export const askRules = [
  { kw: ['主角','他','她','我','角色'], questions: [
    '他/她是什么身份？（职业 / 年龄 / 生存状态）',
    '故事开场时他/她正处在什么处境？',
    '他/她最想要什么？（一句话说清欲望）',
    '他/她最怕什么？（这个恐惧会不会最终成真？）',
  ]},
  { kw: ['AI','机器人','系统','智能','算法','模型'], questions: [
    '这个 AI / 系统是 AGI 还是弱 AI？它有自我意识吗？',
    '它的能力边界在哪？什么它做不到？',
    '它跟主角是什么关系——工具 / 伙伴 / 敌人 / 神？',
  ]},
  { kw: ['未来','2045','2050','赛博','科幻','近未来'], questions: [
    '具体是哪一年？',
    '这个未来跟现在最大的不同点是什么？（一个就够）',
    '普通人在这个未来里过得比现在好还是差？',
  ]},
  { kw: ['现代','都市','城市','上海','北京','成都','深圳','广州','重庆','杭州'], questions: [
    '是现在的还是特定年代的？',
    '这座城市在故事里是背景板，还是有具体的角色感？',
    '主角跟这座城的关系是什么——归属 / 逃离 / 陌生？',
  ]},
  { kw: ['死','杀','血','暴力','枪','刀'], questions: [
    '这个暴力元素是主线还是背景？',
    '主角是施暴者、受害者，还是旁观者？',
    '暴力发生的那一刻，读者应该心疼谁？',
  ]},
  { kw: ['孤独','无力','绝望','愤怒','痛苦','麻木','焦虑'], questions: [
    '这个情绪谁承受？主角还是环境里的所有人？',
    '这个情绪的源头是什么？',
    '故事结尾这个情绪会被解决、缓解，还是加深？',
  ]},
  { kw: ['爱','爱情','暗恋','夫妻','喜欢','恋人','情人'], questions: [
    '这段感情是主线还是副线？',
    '两个人谁更主动？谁更被动？',
    '结局是圆满、错过，还是走散？',
  ]},
  { kw: ['记忆','遗忘','失忆','回忆'], questions: [
    '是主动删除还是被动失去？',
    '失去的是好回忆还是坏回忆？',
    '主角想不想找回来？',
  ]},
  { kw: ['如果','假如','万一','要是'], questions: [
    '这个「如果」如果成真，最先改变的是什么？',
    '谁最受影响？',
    '这个「如果」是浪漫化的，还是恐怖化的？',
  ]},
  { kw: ['反派','敌人','对手','坏人','恶'], questions: [
    '反派的动机是什么？',
    '他觉得自己是好人吗？',
    '他和主角有没有共同点？（有的话，就有力量）',
  ]},
];

export const fallbackAsks = [
  '这段想法你是在什么场景下冒出来的？',
  '你最想让读者读到这里时产生什么反应？',
  '有没有具体的画面或台词，已经在你脑子里成型了？',
  '一句话概括这个故事，会是哪一句？',
];
